module.exports = __webpack_public_path__ + "img/by-nc-nd.0836282d.png";